import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../assets/images/logo.jpg";
import axios from "axios";
import {
  Toolbar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
} from "@mui/material";
import {
  Home as HomeIcon,
  AccountCircle as AccountCircleIcon,
  LocalOffer as LocalOfferIcon,
  Category as CategoryIcon,
  Inventory as InventoryIcon,
  Image as ImageIcon,
  ShoppingCart as ShoppingCartIcon,
  Person as PersonIcon,
  TextSnippet as TextSnippetIcon,
  PhoneCallback as PhoneCallbackIcon,
} from "@mui/icons-material";

const sidebar = [
  {
    title: "Tổng quan",
    icon: <HomeIcon />,
    slug: "/admin",
  },
  {
    title: "Danh mục",
    icon: <CategoryIcon />,
    slug: "/admin/category",
  },
  {
    title: "Liên hệ",
    icon: <PhoneCallbackIcon />,
    slug: "/admin/contact",
  },
  {
    title: "Đơn hàng",
    icon: <ShoppingCartIcon />,
    slug: "/admin/order",
  },
  {
    title: "Sản phẩm",
    icon: <InventoryIcon />,
    slug: "/admin/product",
  },
  {
    title: "Mã giảm giá",
    icon: <LocalOfferIcon />,
    slug: "/admin/coupon",
  },
  {
    title: "Bài viết",
    icon: <TextSnippetIcon />,
    slug: "/admin/post",
  },
  {
    title: "Hình ảnh",
    icon: <ImageIcon />,
    slug: "/admin/image",
  },
  {
    title: "Người dùng",
    icon: <PersonIcon />,
    slug: "/admin/user",
  },
  {
    title: "Người đăng ký",
    icon: <AccountCircleIcon />,
    slug: "/admin/customer",
  },
];

const AdminSidebar = () => {
  const navigate = useNavigate();

  const handdleLogout = async () => {
    try {
      await axios.post(`/api/v1/auth/logout`);
    } catch (error) {
      console.log(error);
    }

    localStorage.removeItem("accessToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("permissions");
    navigate(`/admin/login`);
  };

  return (
    <div>
      <Toolbar sx={{ width: "100%", pt: 2 }}>
        <Box
          component="img"
          sx={{
            width: "100%",
            height: 50,
            objectFit: "cover",
            borderRadius: "8px",
            mb: 2,
          }}
          alt=""
          src={Logo}
        />
      </Toolbar>
      <Divider />
      <List>
        {sidebar.map((item, idx) => (
          <ListItem key={idx} disablePadding>
            <ListItemButton component={Link} to={item.slug}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Button
        variant="contained"
        color="primary"
        sx={{
          position: "absolute",
          bottom: 16,
          left: 50,
        }}
        onClick={handdleLogout}
      >
        Đăng xuất
      </Button>
    </div>
  );
};

export default AdminSidebar;
